import { render, staticRenderFns } from "./OdontogramaInicial.vue?vue&type=template&id=f363ab82&scoped=true"
import script from "./OdontogramaInicial.vue?vue&type=script&lang=js"
export * from "./OdontogramaInicial.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaInicial.vue?vue&type=style&index=0&id=f363ab82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f363ab82",
  null
  
)

export default component.exports